import * as i0 from '@angular/core';
import { input, model, Component, EventEmitter, ContentChildren, Output } from '@angular/core';
import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import * as i1 from '@digipay/ngx-badge';
import { NgxBadgeModule } from '@digipay/ngx-badge';
import { NgxIcon } from '@digipay/ngx-icon';
const _c0 = ["*"];
function NgxTabsComponent_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 4);
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", tab_r2.iconName())("type", tab_r2.iconType());
  }
}
function NgxTabsComponent_For_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ngx-badge", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("mode", ctx_r2.badgeModeMap[tab_r2.state()])("status", ctx_r2.badgeStatusMap[tab_r2.state()]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r2.badgeContent(), " ");
  }
}
function NgxTabsComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function NgxTabsComponent_For_3_Template_div_click_0_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectTab(tab_r2));
    });
    i0.ɵɵtemplate(1, NgxTabsComponent_For_3_Conditional_1_Template, 1, 2, "ngx-icon", 4);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, NgxTabsComponent_For_3_Conditional_3_Template, 2, 3, "ngx-badge", 5);
    i0.ɵɵelement(4, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    i0.ɵɵclassProp("active", tab_r2.state() === "selected")("disabled", tab_r2.state() === "disabled");
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, tab_r2.iconName() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r2.label(), " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, tab_r2.badgeContent() !== undefined ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active-progress", tab_r2.state() === "selected");
  }
}
let NgxTabComponent = /*#__PURE__*/(() => {
  class NgxTabComponent {
    constructor() {
      this.label = input.required();
      this.active = model(false);
      this.badgeContent = input();
      this.iconName = input('');
      this.iconType = input('linear');
      this.state = model.required();
    }
    static {
      this.ɵfac = function NgxTabComponent_Factory(t) {
        return new (t || NgxTabComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxTabComponent,
        selectors: [["ngx-tab"]],
        inputs: {
          label: [i0.ɵɵInputFlags.SignalBased, "label"],
          active: [i0.ɵɵInputFlags.SignalBased, "active"],
          badgeContent: [i0.ɵɵInputFlags.SignalBased, "badgeContent"],
          iconName: [i0.ɵɵInputFlags.SignalBased, "iconName"],
          iconType: [i0.ɵɵInputFlags.SignalBased, "iconType"],
          state: [i0.ɵɵInputFlags.SignalBased, "state"]
        },
        outputs: {
          active: "activeChange",
          state: "stateChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 1,
        consts: [[3, "hidden"]],
        template: function NgxTabComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hidden", ctx.state() !== "selected");
          }
        },
        encapsulation: 2
      });
    }
  }
  return NgxTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxTabsComponent = /*#__PURE__*/(() => {
  class NgxTabsComponent {
    constructor() {
      this.onStateChange = new EventEmitter();
      this.badgeStatusMap = {
        selected: 'info',
        enabled: 'info',
        disabled: 'inactive'
      };
      this.badgeModeMap = {
        selected: 'fill',
        enabled: 'bold',
        disabled: 'bold'
      };
    }
    selectTab(selectedTab) {
      if (selectedTab.state() === 'disabled') {
        return;
      }
      this.tabs.forEach(tab => {
        if (tab === selectedTab) {
          tab.state.set('selected');
          this.onStateChange.emit(tab.state());
        } else if (tab.state() !== 'disabled') {
          tab.state.set('enabled');
        }
      });
    }
    static {
      this.ɵfac = function NgxTabsComponent_Factory(t) {
        return new (t || NgxTabsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxTabsComponent,
        selectors: [["ngx-tabs"]],
        contentQueries: function NgxTabsComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NgxTabComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
          }
        },
        outputs: {
          onStateChange: "onStateChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 0,
        consts: [[1, "tabs"], [1, "tab-headers"], [1, "tab-header", 3, "active", "disabled"], [1, "tab-header", 3, "click"], [3, "name", "type"], ["size", "sm", "type", "count", 3, "mode", "status"]],
        template: function NgxTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵrepeaterCreate(2, NgxTabsComponent_For_3_Template, 5, 9, "div", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.tabs);
          }
        },
        dependencies: [NgxBadgeModule, i1.NgxBadgeComponent, NgxIcon],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{font-family:inherit;direction:rtl}.tabs[_ngcontent-%COMP%]   .tab-headers[_ngcontent-%COMP%]{display:flex;justify-content:space-between;border-bottom:1px solid #DFE1E5}.tabs[_ngcontent-%COMP%]   .tab-headers[_ngcontent-%COMP%]   .tab-header[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:flex-end;position:relative;gap:4px;flex-grow:1;padding:10px 0;cursor:pointer;color:#74777c;font-size:12px;font-weight:450;line-height:20px;margin:0 10px;transition:border-bottom .3s}.tabs[_ngcontent-%COMP%]   .tab-headers[_ngcontent-%COMP%]   .tab-header.active[_ngcontent-%COMP%]{color:#000}.tabs[_ngcontent-%COMP%]   .tab-headers[_ngcontent-%COMP%]   .tab-header.disabled[_ngcontent-%COMP%]{color:#b4b7bd}.tabs[_ngcontent-%COMP%]   .tab-headers[_ngcontent-%COMP%]   .tab-header[_ngcontent-%COMP%]   .active-progress[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;height:4px;border-radius:4px 4px 0 0;background-color:#0e0c09}"]
      });
    }
  }
  return NgxTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-tabs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTabComponent, NgxTabsComponent };
